module.exports = __webpack_public_path__ + "media/images/about_us/tree-daf804bbe9b23bf7dafe30c8e2dbabb7.svg";